import { FunctionComponent } from 'react'
import Submenu from '../../components/Submenu'
import {
  Zap,
  Bell,
  MapPin,
  CreditCard,
  MessageSquare,
  Image as ImageIcon
} from 'react-feather'

const Settings: FunctionComponent = () => {
  return (
    <Submenu
      basePath={'/settings'}
      // Ordered by how a brewery actually onboards, not alphabetically:
      // connect payments, set branding (wallet cards need a logo), then the
      // ways of reaching members. Billing is last - it is the one thing an
      // org rarely needs to touch after signing up.
      items={[
        {
          id: 'integrations',
          icon: Zap,
          title: 'Integrations',
          subPath: ''
        },
        {
          // Early deliberately: Apple requires an icon on every pass, so
          // wallet cards cannot be enabled without this.
          id: 'branding',
          icon: ImageIcon,
          title: 'Branding',
          subPath: '/branding'
        },
        {
          // Shown to every org: the page itself explains that SMS is a Pro
          // feature, which is more use than an item that silently isn't there.
          id: 'sms',
          icon: MessageSquare,
          title: 'SMS marketing',
          subPath: '/sms'
        },
        {
          id: 'locations',
          icon: MapPin,
          title: 'Locations',
          subPath: '/locations'
        },
        {
          id: 'notifications',
          icon: Bell,
          title: 'Notifications',
          subPath: '/notifications'
        },
        {
          id: 'billing',
          icon: CreditCard,
          title: 'Billing',
          subPath: '/billing'
        }
      ]}
    />
  )
}

export default Settings
